import React from 'react'
import { createRoot } from 'react-dom/client'
import { ProductResources } from './ProductResources'

createRoot(document.getElementById('product-resources-mountpoint')!).render(
	<ProductResources />,
)
